import { Instagram } from '@material-ui/icons';
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import "../../style/Menu.scss"
import firebase from 'firebase/app'
import { UserContext } from '../../App';

const Menu = ({menuOpen, setMenuOpen}) => {
    const [logInUser, setLogInUser] = useContext(UserContext);
    const handleLogOut = () => {
        firebase.auth().signOut()
        sessionStorage.removeItem('token')
      }
    return (
        <div className={"menu " + (menuOpen && "active")} id="menu">
            <ul>
                <li onClick={()=>setMenuOpen(false)}>
                   <Link to="/Dashboard"><a> Dashboard</a></Link>
                </li>
                <li onClick={()=>setMenuOpen(false)}>
                {
                            logInUser.email ? <Link to="/" onClick={handleLogOut}><span >SignOut</span></Link>:<Link to="/login"><span>Signin</span></Link>
                }
                </li>
                <li onClick={()=>setMenuOpen(false)}>
                    <a href="/" target="_blank"><Instagram className="icon"/></a>
                </li>
                <p>* For More Details Check Out Instagram</p>
            </ul>
        </div>
    );
};

export default Menu;